export default "__VITE_ASSET__DxN0wnT4__"